// 2026-10-08 別のドメイン（ec.jp-ecol.com 以外）へのリンクを、新しいタブで開き、印を付ける。
// テーマで書いたリンク（メニュー・フッター・トップ・動画と設置事例）は snippets/jp-ecol-ext.liquid で付けてある。
// ここでは、商品の説明文・ページの本文など、HTML をテーマで書いていないリンクにだけ付ける（印が付いているリンクは触らない）。
(() => {
  const SAME = [location.host, 'ec.jp-ecol.com'];
  const SKIP = '.shopify-payment-button, shopify-payment-terms, [data-jd-ext-skip]';
  const ICON = '<svg class="jd-ext-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/></svg>';
  const run = () => {
    const main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    main.querySelectorAll('a[href]').forEach((a) => {
      if (a.closest(SKIP) || a.querySelector('.jd-ext-icon')) return;
      let url;
      try { url = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
      if (!/^https?:$/.test(url.protocol) || SAME.includes(url.host)) return;
      a.target = '_blank';
      const rel = new Set((a.rel || '').split(/\s+/).filter(Boolean));
      rel.add('noopener');
      a.rel = Array.from(rel).join(' ');
      // 文字のあるリンクだけに印を付ける（画像だけのリンクは読み上げの文だけ足す）
      if (a.textContent.trim()) a.insertAdjacentHTML('beforeend', ICON);
      if (!/新しいタブ/.test(a.textContent)) a.insertAdjacentHTML('beforeend', '<span class="visually-hidden">（新しいタブで開きます）</span>');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
